/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  // backend_url: "https://be-dev.easylink.tn:8442/easylink-api-admin/v1/",
  // backend_url_Adh: "https://be-dev.easylink.tn:8442/easylink-api-adherent/v1/",
  // backend_url_Convention:"https://be-dev.easylink.tn:8442/easylink-api-convention/v1/",
  // local_backend_url: "http://localhost:8080/v1/",
  // image_url: "http://ged.easylink.tn/easylink",
  // backend_url_Ord: "https://be-dev.easylink.tn:8442/easylink-api-ordering/v1/",
  // backrnd_url_Pro: "https://be-dev.easylink.tn:8442/easylink-api-provider/v1/",
  // backend_url_Product: "https://be-dev.easylink.tn:8442/easylink-api-product/v1/",
  // backend_url_Provider: "https://be-dev.easylink.tn:8442/easylink-api-provider/v1/",
  // backend_url_Eligibility:"https://be-dev.easylink.tn:8442/easylink-api-eligibility/v1/eligibility/",
  // backend_url_Comptabilite:"https://be-dev.easylink.tn:8442/easylink-api-comptabilite/v1/",
  // backend_url_Css: "https://be-dev.easylink.tn:8442/easylink-api-css/v1/",
  // partnerdashbord: "http://localhost:4200/pages/dashboard",
  // backend_url_Otp: "https://be-dev.easylink.tn:8442/easylink-api-otp/otp/",
  


   backend_url:"https://api1.easylink.tn:8443/easylink-api-admin/v1/",
  backend_url_Adh:"https://api1.easylink.tn:8443/easylink-api-adherent/v1/",
  backend_url_Convention:"https://api1.easylink.tn:8443/easylink-api-convention/v1/",
  //backend_url:"http://149.202.3.56:8080/administration-easylink-api-1.0.0-SNAPSHOT/v1/",
  local_backend_url:'http://localhost:8080/v1/',
  image_url:'http://87.98.167.49/easylink',
  backend_url_Ord:'https://api1.easylink.tn:8443/easylink-api-ordering/v1/',
  backrnd_url_Pro:"https://api1.easylink.tn:8443/easylink-api-provider/v1/",
  backend_url_Product:"https://api1.easylink.tn:8443/easylink-api-product/v1/",
  backend_url_Provider:"https://api1.easylink.tn:8443/easylink-api-provider/v1/",
  backend_url_Eligibility:"https://api1.easylink.tn:8443/easylink-api-eligibility/v1/eligibility/",
  backend_url_Comptabilite:"https://api1.easylink.tn:8443/easylink-api-comptabilite/v1/",
  backend_url_Css:"https://api1.easylink.tn:8443/easylink-api-css/v1/",
  backend_url_Otp:"https://api1.easylink.tn:8443/easylink-api-otp/otp/",
  partnerdashbord:"https://bo.easylink.tn/pages/dashboard",



  // production: true,
  // backend_url:"https://api1.easylink.tn:8443/easylink-api-admin/v1/",
  // backend_url_Adh:"https://api1.easylink.tn:8443/easylink-api-adherent/v1/",
  // backend_url_Convention:"https://api1.easylink.tn:8443/easylink-api-convention/v1/",
  // // backend_url:"http://149.202.3.56:8080/administration-easylink-api-1.0.0-SNAPSHOT/v1/",
  // local_backend_url:'http://localhost:8080/v1/',
  // image_url:'http://87.98.167.49/easylink',
  // backend_url_Ord:'https://api1.easylink.tn:8443/easylink-api-ordering/v1/',
  // backrnd_url_Pro:"https://api1.easylink.tn:8443/easylink-api-provider/v1/",
  // backend_url_Product:"https://api1.easylink.tn:8443/easylink-api-product/v1/",
  // backend_url_Provider:"https://api1.easylink.tn:8443/easylink-api-provider/v1/",
  // backend_url_Eligibility:"https://api1.easylink.tn:8443/easylink-api-eligibility/v1/eligibility/",
  // backend_url_Comptabilite:"https://api1.easylink.tn:8443/easylink-api-comptabilite/v1/",
  // backend_url_Css:"https://api1.easylink.tn:8443/easylink-api-css/v1/",
  // backend_url_Otp:"https://api1.easylink.tn:8443/easylink-api-otp/otp/",
  // partnerdashbord:"http://localhost:4300//pages/dashboard",
};
